
;/*** Source: js/script.js ***/

;(function($, $window, $document, undefined){
// Site wide variables
    var $html, $body, $app, $header, $main, $footer, $banners, $dropzone, $entries,
        resize      = 0, 
        scroll      = 0, 
        playing     = 0,
        breakpoints = { xs : null, sm : null, md : null, lg : null },
        headers     = {
            x_wp_nonce  : Monk.nonce,
            x_mnk_user  : window.URLSearchParams ? (new URLSearchParams( location.search )).get('mnk_debug_user') || 0 : 0
        },
        wavesurfer  = {
            waveColor       : '#fff',
            progressColor   : 'lightgray',
            cursorColor     : '#fff'
        },
        Model       = Backbone.Model.extend(),
        Collection  = Backbone.Collection.extend({
            model   : Model,
            links   : {},
            load    : function(link, el){
                
                if(this.links[link]) {
                                        
                    this.fetch({
                        headers : headers,
                        url     : this.links[link]
                    });
                    
                    $(el).addClass('invisible').tooltip('hide');
                    
                }
                
            }
        }),
        View        = Backbone.View.extend({
            
            wavesurfer  : null,
            
            events              : {
                "click [data-model]"                : '_call_model_method',
                "click [role=play],[role=pause]"    : 'play'
            },
            
            render              : function(atts, callback) {
                
                var model = this.model ? this.model.attributes : {};
                
                window.requestAnimationFrame( function(){
                                    
                    if(typeof this.view.template === 'function') {

                        this.view.$el.html( this.view.template( this.atts ) );

                        this.view.model && this.view.model.set('_rendered', true);
                        
                        if(typeof this.cb === 'function')
                            this.cb.call( this.view ); 

                    }
                    
                }.bind({
                    view    : this,
                    atts    : atts || model,
                    cb      : callback
                }) );
                                
                return this;
                
            },
            
            blockUI     : function() {
                
                this.$el.loading();
                
            },
            
            unblockUI   : function(){
                
                this.$el.trigger('loaded');
                
            },
            
            play        : function(){

                this.wavesurfer.playPause();

            }
            
        }),
        Event       = _.extend({}, Backbone.Events),
        Views       = {
            entry       : View.extend({

                tagName     : 'li',
                className   : 'media entry',

                events      : {
                    "click [role=vote]" : "vote",
                    "click [role=play],[role=pause]" : "play"
                },

                vote        : function(e){

                    var score = $(e.currentTarget).tooltip('hide').data('vote');
                    
                    if(Monk.user.display_name)
                        this.model.vote( score );
                    
                    else
                        Monk.api.dialog('login');
                    

                },
                
                updateState : function(){
                    
                    var current_user = this.model.get('current_user');
                    
                    this.$el
                        .removeClass('has-voted')
                        .removeClass('vote-up')
                        .removeClass('vote-down');
                    
                    if(current_user.has_voted) {

                        this.$el.addClass('has-voted').addClass({
                            '1'     : 'vote-up',
                            '-1'    : 'vote-down'
                        }[current_user.score] );
                        
                    }
                    
                },
                
                initialize  : function() {

                    this.render(null, function(){

                        this.wavesurfer = WaveSurfer.create( $.extend({
                            container       : this.$('[role=waveform]').get(0),
                            scrollParent    : true,
                            minPxPerSec     : 10,
                            fillParent      : true
                        }, wavesurfer) );
                        
                        $(this.wavesurfer.container).loading();

                        this.wavesurfer.load( this.model.get('source_url') );
                        
                        this.wavesurfer.on( 'ready', function(){
                            
                            $(this).trigger('loaded');
                            
                        }.bind(this.wavesurfer.container) );
                        
                        this.wavesurfer.on( 'play', function(){
                            
                            this.$('.playback').addClass('playing').removeClass('paused');

                            if(playing !== this.wavesurfer) {

                                playing && playing.stop();

                                playing = this.wavesurfer;

                            }
                            
                        }.bind(this) );
                        
                        this.wavesurfer.on( 'pause', function(){
                            
                            this.$('.playback').addClass('paused').removeClass('playing');
                                                        
                        }.bind(this) );
                        
                        if (this.model.get('current_user').has_voted)

                            Number(Monk.is_voting_period) && this.$el.tooltip({
                                title: 'You have already voted!',
                                container: 'body'
                            });

                        else

                            this.$('[role=vote]').tooltip();
                        
                    });

                    this.$el.appendTo($entries);   
                        
                    this.listenTo( this.model, 'request',   this.blockUI.bind(this) );
                    this.listenTo( this.model, 'sync',      this.unblockUI.bind(this) );
                    this.listenTo( this.model, 'change',    this.updateState.bind(this) );
                    
                    this.updateState();

                }

            }),
            master      : View.extend({

                playhead            : null,
                contributors        : null,

                events      : {
                    "click [role=play],[role=pause]"    : "play",
                },

                track       : function(time) {

                    var model = this.collection.find(function(entry){

                        return time 
                        && time >= entry.get('media_details').mastertrack_timestamp_start 
                        && time <= entry.get('media_details').mastertrack_timestamp_end;

                    });

                    this.playhead.render( model, this.wavesurfer.backend.getPlayedPercents() * 100 );

                },

                refreshList : function(){

                    var list    = '',
                        tmpl    = _.template('<tr><td><%= batch_no %></td><td><%= track %></td><td><%= artist %></td></tr>');

                    this.collection.each(function(entry){

                        list += tmpl({
                            batch_no    : entry.get('_batch_no'),
                            track       : entry.get('title').rendered,
                            artist      : entry.get('author').display_name
                        });

                    });

                    this.contributors.$el.html(list);

                },

                initialize  : function(){

                    this.contributors = new View({
                        el  : document.querySelector('#contributors [role=list]')
                    });

                    this.wavesurfer = WaveSurfer.create( $.extend({
                        container   : this.$('[role=waveform]').get(0)
                    }, wavesurfer) );

                    this.wavesurfer.on('audioprocess', this.track.bind(this));
                    this.wavesurfer.on('pause', this.track.bind(this));
                    this.wavesurfer.on('finish', this.track.bind(this));
                    
                    this.wavesurfer.on('ready', function(){
                        
                        $(this.wavesurfer.container).trigger('loaded');
                        
                    }.bind(this));
                    
                    this.wavesurfer.on( 'play', function(){

                        this.$('.playback').addClass('playing').removeClass('paused');
                        
                        if(playing !== this.wavesurfer) {

                            playing && playing.stop();

                            playing = this.wavesurfer;
                            
                        }


                    }.bind(this) );

                    this.wavesurfer.on( 'pause', function(){

                        this.$('.playback').addClass('paused').removeClass('playing');
                        
                    }.bind(this) );
                    
                    $(this.wavesurfer.container).loading();

                    this.wavesurfer.load( Monk.master_track );

                    this.playhead = new Views.playhead();

                    this.playhead.$el.appendTo( this.wavesurfer.container );

                    Event.listenTo( this.collection, 'update', this.refreshList.bind(this) );


                }

            }),
            playhead    : View.extend({

                className   : 'playhead',
                tagName     : 'div',
                render      : function(model, pos){

                    this.model = model;

                    if(this.model) {

                        View.prototype.render.call(this);
                        this.el.style.opacity = 1;

                    }

                    else this.el.style.opacity = 0;

                    this.el.style.left = pos + '%';

                }

            }),
            dialog      : View.extend({
                
                events  : {
                    'click [type=submit]'    : 'submit'
                },
                
                submit  : function(e) {
                    
                    var $form   = this.$('form'),
                        input   = $form.serializeArray(),
                        action  = $(e.target).attr('name'),
                        data    = {}, 
                        v;
                    
                    e.preventDefault();
                                        
                    for(v in input)
                        data[ input[v]['name'] ] = input[v]['value'];
                    
                    data.action = action;
                    
                    this.$('.form-group').tooltip({
                        title   : function(){

                            return $(this).data('validation_error');

                        },
                        trigger	: 'manual'
                    });
                    
                    $.ajax($form.attr('action'), {
                        data        : data,
                        context     : this,
                        dataType    : 'json',
                        headers     : headers,
                        method      : $form.attr('method').toLowerCase(),
                        success     : function(res, status, jqxhr) {

                            Monk.user = {
                                display_name    : res.display_name,
                                can_update_name : false
                            };
                            
                            this.hide();

                        },
                        error       : function(jqxhr) {
                            
                            if(jqxhr.responseJSON.code === 'validation_error') {
                                
                                var errors = jqxhr.responseJSON.data.errors;
                                
                                
                                for(var e in errors) {
                                    
                                    this.$('[name=' + e + ']').parent().data('validation_error', errors[e]).addClass('has-error').tooltip('show');
                                    
                                }
                                
                            }
                            
                        },
                        complete    : function() {
                            
                            this.$('[role=document]').trigger('loaded');
                            
                        }
                    });
                    
                    this.$('[role=document]').loading({
                        container   : this.el
                    });
                    
                },
                
                show    : function(){
                 
                    this.$el.modal('show');
                    
                },
                
                hide    : function(){
                    
                    this.$el.modal('hide');
                    
                }
                
                
                
            })
        },
        Models      = {
            entry   : Model.extend({
                
                vote    : function( score ){

                    if( !this.get('current_user').has_voted ) {

                        this.save({
                            '_vote_entry_v1'    : score,
                            '_wpnonce'          : Monk.nonce
                        }, {
                            patch   : true,
                            headers : headers
                        });

                    }

                }

            }),
       },
        Collections = {

            master  : Collection.extend({
                url         : Monk.rest.master
            }),
            
            entries : Collection.extend({
                url     : Monk.rest.entries,
                model   : Models.entry
            })

        },
        Login       = function(data){
            
            $('#login [role=document]').loading({
                container   : '#login'
            });
            
            $.ajax(Monk.rest.login, {
                data        : data,
                dataType    : 'json',
                headers     : headers,
                method      : 'POST',
                success     : function(res, status, jqxhr) {
                    
                    if(res.user_logged_in) {
                        
                        window.location = res.redirect;
                        
                    }
                    
                }
            });
            
        };
    
        
    $.extend(Monk, {
        
        ui      : [],
        api     : {
            
            refreshEntries  : function(){
                
                _.each(Monk.api.entries.where({ '_rendered' : false }), function(entry){
                    
                    entry.url = Monk.api.entries.url + '/' + entry.id; 
                    
                    if( entry.get('template') ) {

                        Monk.ui[ entry.id ] = new Views[ entry.get('template') ]({
                            model   : entry,
                            id      : 'entry-' + entry.id
                        });

                    }
                    
                }, Monk);
             
            },
            entriesSynced   : function(entries, response, options) {
                
                var links, link, l;
                
                if(entries instanceof Collection) {
                    
                    entries.links = {};
                                        
                    links = options.xhr.getResponseHeader('link').split(', ');

                    $entries.trigger('loaded');

                    if(!this.api.entries.length) {

                        $('#no-entries').removeClass('hide');

                    }
                    
                    if(links) {
                        
                        for(l in links) {
                            
                            link = links[l].match(/^\<(.+?)\>\;\srel="(\w+)"$/i);

                            if(link) {

                                entries.links[ link[2] ] = link[1];

                            }
                            
                        }
                        
                    }
                    
                    if(entries.links['next']) {
                        
                        $entries.next('button').removeClass('invisible');
                        
                    } else 
                        
                        $entries.next('button').remove();
                    
                    
                }
                
            }, 
            blockUI         : function(obj, response, options) {
                
                if(obj instanceof Collection)
                
                    window.setTimeout(function(){

                        $entries.loading();

                    }, 200);
                
            },
            initialise      : function(){
                
                $('[type="text/x-mnk-template"]').each(function(){

                    var $this   = $(this),
                        slug    = $this.data('slug');
                    
                    if( Views[slug] ) {
                        
                        Views[slug].prototype.template = _.template( $this.html() );
                        
                    }

//                   $this.remove();

                });
                
                Monk.api.entries    = new Collections.entries();
                
                Monk.api.master     = new Collections.master(); 
                
                Event.listenTo( Monk.api.entries, 'update',     Monk.api.refreshEntries.bind(Monk)  );
                Event.listenTo( Monk.api.entries, 'sync',       Monk.api.entriesSynced.bind(Monk)   );
                Event.listenTo( Monk.api.entries, 'request',    Monk.api.blockUI.bind(Monk)         );
                                
                Monk.api.master.fetch({
                    headers : headers,
                    data    : {
                        '_wpnonce'  : Monk.nonce
                    }
                });
                
                Monk.api.entries.fetch({
                    headers : headers,
                    data    : {
                        '_wpnonce'  : Monk.nonce
                    }
                });
                
                Monk.ui['master'] = new Views.master({
                    
                    el          : document.getElementById('master-track'),
                    collection  : Monk.api.master
                    
                });
                
                Monk.ui['dialog'] = new Views.dialog({
                    el  : document.querySelector('[role=dialog]')
                });
                                
                if(Monk.user.can_update_name) {
                    
                    Monk.api.dialog('update-displayname');
                    
                }
                
                $html.addClass('initialised');
                
            },
            loginFB         : function(){
                
                if(window.FB) {
                    
                    FB.login(function(response){
                        
                        if(response.status === 'connected') {
                            
                            Login({
                                method  : 'fb',
                                token   : response.authResponse.accessToken
                            });
                            
                        }
                        
                    }, {
                        scope   : 'public_profile,email'
                    });
                    
                }
                
            },
            loginGg         : function(){
                
                var googleAuth = gapi.auth2.getAuthInstance(),
                    promise;
                
//                if( !googleAuth.isSignedIn.get() ) {
                    
                    googleAuth.signIn().then(function(googleUser){
                        
                        Login({
                            method  : 'google',
                            token   : googleUser.getAuthResponse(true).id_token
                        });
                        
                    }, function(){
                        
                        
                        
                    });
                    
//                }
                
            },
            dialog          : function(ui){
                
                var el = document.getElementById(ui);
                
                if(el) {
                    
                    Monk.ui.dialog.setElement(el).show();
                    
                }
                
            }
        }
        
    });
    
    
    window.mnkGoogleApisInit = function() {
        
        gapi.load('auth2', function() {

            gapi.auth2.init({
                client_id   : Monk.google.client_id,
                scope       : 'profile email'
            });

        });
            
    }

    
    $document.ready(function(){
               
        /* Uncomment what you need */
        $html           = $('html').removeClass('no-js').addClass('domready');
        $body           = $('body');
        //$page   = $('#page');
        //$header = $("#masthead");
        //$main   = $("main");
        //$footer = $("#colophon");
        $banners        = $('.banner:has(>.banner)');
        $dropzone       = $('#mp3submit');
        $entries        = $('#entry-list');        
        
        // Disable auto discover for all elements:
        Dropzone.autoDiscover = false;

        $dropzone.dropzone({
            url                 : Monk.rest.entries,
            previewTemplate     : $('#mnk-template-progress-bar').html(),
            paramName           : 'file',
            maxFilesize         : 6,
            uploadMultiple      : false,
            maxFiles            : 1,
            ignoreHiddenFiles   : true,
            headers             : headers,
            clickable           : $('[role=dropzone]', $dropzone).get(0),
            acceptedFiles       : 'audio/mpeg,audio/mp3', //
            previewsContainer   : $('[role=dropzone]', $dropzone).get(0),
            init                : function(){
                
                var $status = $('[role=notice]', $dropzone),
                    dots    = '.',
                    interval;
                
                $dropzone.addClass('ready');
                $dropzone.addClass('idle');                
                
                this.on('sending', function(){
                    
                    $dropzone.removeClass('idle').find('input').attr('disabled', 'disabled');
                    
                    $status.removeClass('hide');

                    interval = window.setInterval(function(){

                        $status.text('Please wait' + dots);

                        dots += '.';

                    }, 500);
                    
                });
                
                this.on('error', function(e, message){
                    
                    $dropzone.find('input').removeAttr('disabled');
                    
                    $('[role=dropzone]', $dropzone).tooltip({
                        trigger : 'manual',
                        title   : message
                    }).tooltip('show');
                    
                    $('.progress', $dropzone).remove();
                    
                });
                
                this.on('complete', function(){
                    
                    $dropzone.addClass('idle');
                    
                    window.clearInterval(interval);
                    $status.addClass('hide');
                    dots = '.';
                    
                });
                
                this.on('success', function(){
                    
                    $dropzone.remove();
                    
                });
                
            }
        });

        // Smooth Scrolling support
        $body.on('click', 'a[href*="#"]:not([href="#"])', function(e) {
            
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                
                var $target = $(this.hash);
                
                $target = $target.length ? $target : $('[name=' + this.hash.slice(1) +']');
                
                if ($target.length) {
                    e.preventDefault();
                    
                    /* Set anchor handlers here */
                    
                    switch($target.attr('role')) {
                            
                            case 'dialog' :
                            
                            $target.modal();
                            
                            break;
                            
                            default :

                            $('html, body').animate({
                                scrollTop: Math.max($target.offset().top - 20, 0)
                            }, 500);
                            
                    }
                                        
                }
                
            }
        });
        
        
        // Enable tooltips for menu items with descriptions
        if ($.fn.tooltip) {

            $(".navbar-nav a[data-description]").tooltip({
                placement: 'bottom',
                title: function () {

                    return $(this).data('description');

                }
            });
            
            $('[data-toggle="tooltip"]').tooltip();

        }
        
        
        // Auto open modals        
        if ($.fn.modal) {
            var $modal = $("#modal");

            $modal.prev('[data-toggle="modal"]').length || $modal.modal({
                backdrop: true /* or 'static' */
            }).on('shown.bs.modal', function () {

                $modal.find('input:first').focus();

            });

        }
        
        
        // Handle Banners with nested banners
        if ($banners.length) {
            
            var slider;

            $banners.each(function () {

                slider = $banners.data('slider');

                if (slider) switch (slider) {

                    case 'slick': // Slick support for banner components. As much as possible it adopts styles from BS' carousel component
                        
                        $banners.slick({
                            //adaptiveHeight: false,
                            //arrows: true,
                            //asNavFor: null,
                            prevArrow: '<a class="left carousel-control" role="button" data-slide="prev"><i class="icon-prev" aria-hidden="true"></i><span class="sr-only">Previous</span></a>',
                            nextArrow: '<a class="right carousel-control" role="button" data-slide="next"><i class="icon-next" aria-hidden="true"></i><span class="sr-only">Next</span></a>',
                            //autoplay: false,
                            //autoplaySpeed: 3000,
                            //centerMode: false,
                            //centerPadding: '50px',
                            //cssEase: 'ease',
                            dots: true, // True for now for testing purposes
                            dotsClass: 'carousel-indicators slick-dots',
                            //fade: true,
                            //focusOnSelect: false,
                            //initialSlide: 0,
                            //lazyLoad: 'ondemand',
                            mobileFirst: true,
                            //pauseOnHover: true,
                            //pauseOnFocus: true,
                            //pauseOnDotsHover: false,
                            //respondTo: 'window',
                            //responsive: {},
                            //rows: 1,
                            slide: '.banner',
                            //slidesPerRow: 1,
                            //slidesToShow: 1,
                            //slidesToScroll: 1,
                            //speed: 500,
                            swipeToSlide: true,
                            //variableWidth: false,
                            //vertical: false,
                            //verticalSwiping: false,
                            zIndex: 1000
                        }).addClass('carousel').children('.slick-list').addClass('banner-group');
                        
                        break;

                    default:
                        $banners[slider]();

                } else $.fn.slider && $banners.slider();

            });

        }
        
        
        $window.trigger('resize', [true]);

        
    });
    
    $window.ready(function(){
        
        $('html').removeClass('loading').addClass('loaded');
        
    }).resize(function(e, init) {
        
        if(!resize){
            
            $body.addClass('resizing');
            
            resize = window.setTimeout(function(){
                
                var width   = $window.width(),
                    height  = $window.height();
                                
                // Breakpoints (determined as the client's min width)
                breakpoints = {
                    xs  : width >= 480  ? true : false,
                    sm  : width >= 768  ? true : false,
                    md  : width >= 992  ? true : false,
                    lg  : width >= 1200 ? true : false
                };
                
                /* Place resize handlers here */

                if(init) {
                    
                    Monk.api.initialise();
                    
                }
                
                
                $window.trigger('resize.monk', [{ width: width, height: height }, init]);
                $body.removeClass('resizing');
                resize = 0;
                
            }, 100);
            
        }
        
    }).scroll(function(e) {
                
        var scrollTop = $window.scrollTop();
        
        window.clearTimeout(scroll);
        
        scroll = window.setTimeout(function() {
            
            /* Set scroll handlers here */
            
            
            $window.trigger('scroll.monk', [scrollTop]);
            scroll = 0;
            
        }, 200);
        
    });
        
    
})(jQuery, jQuery(window), jQuery(document));//